import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from 'src/app/private/services/api.service';

export interface SalesTeamAgentSlot {
  start: string;
  end: string;
}

export interface SalesTeamAgent {
  user_id: number;
  name: string;
  email: string;
  calendar_provider: string;
  free_slots: SalesTeamAgentSlot[];
  slot_count: number;
}

export interface SalesTeamWithSlotsResponse {
  date: string;
  duration_minutes: number;
  agent_count: number;
  agents: SalesTeamAgent[];
  message?: string;
}

@Injectable({
  providedIn: 'root',
})
export class MeetingBookingService {
  constructor(private api: ApiService) {}

  /** Part E — JWT + encryption. */
  getSalesTeamWithSlots(data: {
    client_id: number | string;
    date: string;
    duration_minutes: number;
    timezone?: string;
    user_id?: number | string;
  }): Observable<SalesTeamWithSlotsResponse> {
    return this.api.post(environment.getSalesTeamWithSlots, {
      client_id: Number(data.client_id),
      date: data.date,
      duration_minutes: data.duration_minutes,
      timezone: data.timezone || 'Asia/Kolkata',
      ...(data.user_id != null && data.user_id !== ''
        ? { user_id: Number(data.user_id) }
        : {}),
    });
  }

  bookMeetingSlot(data: {
    client_id: number | string;
    lead_id: number | string;
    meeting_time_stamp: number;
    duration: number;
    timezone?: string;
    client_name?: string;
    client_email?: string;
    client_phone?: string;
    meeting_title: string;
    meeting_desc?: string;
    booking_source?: string;
    assigned_user_id?: number | string;
    user_id?: number | string;
  }): Observable<any> {
    const organizerId = data.assigned_user_id ?? data.user_id;
    return this.api.post(environment.bookMeetingSlot, {
      client_id: String(data.client_id),
      lead_id: Number(data.lead_id),
      meeting_time_stamp: data.meeting_time_stamp,
      duration: Number(data.duration),
      duration_minutes: Number(data.duration),
      timezone: data.timezone || 'Asia/Kolkata',
      client_name: data.client_name || undefined,
      client_email: data.client_email || undefined,
      client_phone: data.client_phone || undefined,
      meeting_title: data.meeting_title,
      meeting_desc: data.meeting_desc || '',
      booking_source: data.booking_source || 'crm',
      ...(organizerId != null && organizerId !== ''
        ? { assigned_user_id: Number(organizerId) }
        : {}),
    });
  }

  rescheduleMeetingSlot(data: {
    booking_id: number | string;
    meeting_time_stamp: number;
    duration: number;
    timezone?: string;
    meeting_title?: string;
    meeting_desc?: string;
    recipients?: string[];
  }): Observable<any> {
    return this.api.post(environment.rescheduleMeetingSlot, {
      booking_id: Number(data.booking_id),
      meeting_time_stamp: data.meeting_time_stamp,
      duration: Number(data.duration),
      duration_minutes: Number(data.duration),
      timezone: data.timezone || 'Asia/Kolkata',
      meeting_title: data.meeting_title,
      meeting_desc: data.meeting_desc ?? '',
      ...(data.recipients?.length
        ? { recipients: data.recipients.filter((email) => email?.trim()) }
        : {}),
    });
  }

  cancelMeetingSlot(data: {
    booking_id: number | string;
    client_id?: number | string;
    reason?: string;
  }): Observable<any> {
    return this.api.post(environment.cancelMeetingSlot, {
      booking_id: Number(data.booking_id),
      client_id: data.client_id != null ? String(data.client_id) : undefined,
      reason: data.reason || 'Cancelled from CRM',
    });
  }

  getAllMeetingDetails(data: {
    client_id: number | string;
    lead_id: number | string;
  }): Observable<any[]> {
    return this.api.post(environment.getAllMeetingDetails, {
      client_id: Number(data.client_id),
      lead_id: Number(data.lead_id),
    });
  }
}
